/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum CreateAndSubmitActionsEnum {
    CREATE = 'CREATE',
    SUBMIT = 'SUBMIT'
}
